import axios from 'axios';
const SearchInst = 'https://rest.sinclair.edu/api/1/index.cfm/Coins/SearchByInst.json?apikey=';
const SearchTransfer = 'https://rest.sinclair.edu/api/1/index.cfm/Coins/SearchByTransfer.json?apikey=';
const SearchCourse = 'https://rest.sinclair.edu/api/1/index.cfm/Coins/SearchByCourse.json?apikey=';


class SearchService {

    searchInst(authToken, s){
        return axios.post(SearchInst + authToken, s)
    }

    searchTransfer(authToken, s){
        return axios.post(SearchTransfer + authToken, s)
    }

    searchCourse(authToken, s){
        return axios.post(SearchCourse + authToken, s)
    }

}

export default new SearchService();